import { render, staticRenderFns } from "./selectEspecialidades.vue?vue&type=template&id=3e073b7e"
import script from "./selectEspecialidades.vue?vue&type=script&lang=js"
export * from "./selectEspecialidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports